<div class="font-lato my-4 flex h-full w-full flex-col rounded-xl bg-white">
  <!-- Toolbar: search · filters -->
  <div
    class="flex flex-wrap items-center gap-3 px-4 py-3"
    [hidden]="showFilterBt"
  >
    <!-- Search — prominent, flex-1 -->
    <div class="relative w-full max-w-xl min-w-64 flex-1">
      <label for="orders-table-search" class="sr-only">Search orders</label>
      <mat-icon
        class="pointer-events-none absolute top-1/2 left-3 !flex !h-4 !w-4 -translate-y-1/2 !items-center !justify-center !text-lg text-black"
        aria-hidden="true"
        >search</mat-icon
      >
      <input
        id="orders-table-search"
        type="search"
        class="comcast-input !mt-0 pl-9 !text-sm"
        [(ngModel)]="searchQuery"
        placeholder="Search"
        autocomplete="off"
      />
    </div>

    <!-- Filters -->
    @if (checkboxFilters.service.children?.length) {
      <app-checkbox-select
        #serviceFilter
        [data]="checkboxFilters.service"
        [placeholder]="'Service'"
        [name]="'Service'"
        (opened)="closeOtherFilters('service')"
      />
    }
    @if (checkboxFilters.status.children?.length) {
      <app-checkbox-select
        #statusFilter
        [data]="checkboxFilters.status"
        [placeholder]="'Status'"
        [name]="'Status'"
        (opened)="closeOtherFilters('status')"
      />
    }
    @if (checkboxFilters.address.children?.length) {
      <app-checkbox-select
        #addressFilter
        [data]="checkboxFilters.address"
        [placeholder]="'Address'"
        [name]="'Address'"
        (opened)="closeOtherFilters('address')"
      />
    }
  </div>

  <app-table-orders
    #orderTable
    [data]="data"
    [loading]="loading"
    [externalQuery]="searchQuery"
    [filterStatus]="checkboxFilters.status.selectedChildren"
    [filterService]="checkboxFilters.service.selectedChildren"
    [filterAddress]="checkboxFilters.address.selectedChildren"
    (filterRemove)="removeFromFilter($event.type, $event.item.attrs.value)"
    (selectOrder)="selectOrder.emit($event)"
  ></app-table-orders>
</div>
